module.exports = __webpack_public_path__ + "static/media/usb-drive.c5302b7a.svg";